import { IFlexiTicketSummary } from '@nx-ng/types';
import {
  GetFareResponse,
  KnownPricePaymentMethod,
  TicketProduct,
} from '../../../client/src';

export const createFlexiSummary = (
  tickets?: GetFareResponse
): IFlexiTicketSummary[] =>
  tickets?.map((ticket: TicketProduct) => ({
    id: ticket.id || 0,
    price: ticket.price?.[0]?.price || 0,
    name: ticket.description || '',
    paymentMethodType: KnownPricePaymentMethod.OneOff,
  })) || [];
